import BuildWealthIcon from "./icons/build-wealth-icon.svg";
import BuildProtectIcon from "./icons/build-protect-icon.svg";
import tickCircleSVG from "./images/bf-tick-circle.svg?url";
import redDangerSVG from "./images/bf-red-danger.svg?url";
import {
  AccountTier,
  BWBRedirectUrl,
  rootUrl,
  UkBWBRedirectUrl,
} from "@bundles/consts";
import { isTier1AndAbove } from "@funds/features/helpers/functions";

export type MenuLink = {
  label: string;
  href?: string;
  soon?: boolean;
};

export type MenusConfig = {
  my_companies: boolean;
  my_pitches: boolean;
  chapter_11_claim: boolean;
};

export const getProductSections = (slug?: string, isUk?: boolean) => {
  const baseUrl = `${rootUrl}/profile/${slug}`;

  return [
    {
      title: "Build Your Bitcoin Wealth",
      titleBackground: "bg-primary-regular",
      links: [
        {
          label: isUk ? "Buy Bitcoin" : "Buy Bitcoin & Stake ETH",
          url: `${baseUrl}/funds/myFunds`,
          icon: BuildWealthIcon,
        },
        {
          label: isUk ? "Stake ETH" : "Invest in Bitcoin Public Shares",
          url: isUk
            ? `${baseUrl}/funds/stakingEth`
            : `${baseUrl}/shares/public-equity`,
          icon: BuildWealthIcon,
        },
        {
          label: isUk
            ? "Convert Fiat to Stablecoin"
            : "Invest in Bitcoin Private Equity",
          url: isUk
            ? `${baseUrl}/funds/manage/deposit?currency=bfusd`
            : `${rootUrl}/market/spvs`,
          icon: BuildWealthIcon,
        },
      ],
    },
    {
      title: isUk
        ? "Manage Your Bitcoin Wealth"
        : "Protect Your Bitcoin Wealth",
      titleBackground: "bg-primary-dark",
      links: [
        {
          label: "Bitcoin Financial Planning",
          url: isUk ? UkBWBRedirectUrl : BWBRedirectUrl,
          icon: BuildProtectIcon,
        },
        {
          label: "Bitcoin Tax Technology",
          url: isUk ? UkBWBRedirectUrl : BWBRedirectUrl,
          icon: BuildProtectIcon,
        },
        {
          label: "Bitcoin Inheritance Technology",
          url: isUk ? UkBWBRedirectUrl : BWBRedirectUrl,
          icon: BuildProtectIcon,
        },
      ],
    },
  ];
};

export const getProfileSubMenuLinks = ({
  slug,
  isMobile,
  menusConfig,
  step,
}: {
  slug?: string;
  isMobile?: boolean;
  menusConfig: MenusConfig | null;
  step: number;
}): MenuLink[] => {
  let links = [];
  const baseLinks = [
    { label: "My Companies", href: `/profile/${slug}/companies` },
    { label: "My Pitches", href: `/profile/${slug}/pitches` },
    { label: "Chapter 11 Claim", href: `/profile/${slug}/chapter-11-claim` },
    { label: "Portfolio Builder", href: "", soon: true },
    { label: "Account", href: `/profile/${slug}/account` },
    { label: "Security", href: `/profile/${slug}/account?tab=security` },
    { label: "Support", href: "/support" },
  ];

  const mobileLinks = [
    {
      label: step > 0 ? "Start" : "Membership",
      href: `/profile/${slug}/membership`,
    },
    { label: "My Funds", href: `/profile/${slug}/funds/myFunds` },
    { label: "My Shares", href: `/profile/${slug}/shares` },
    { label: "Markets", href: "/market/" },
    { label: "Staking", href: `/profile/${slug}/funds/stakingEth` },
  ];

  links = baseLinks;

  if (!menusConfig?.chapter_11_claim) {
    links = links.filter((x) => x.label !== "Chapter 11 Claim");
  }

  if (!menusConfig?.my_companies) {
    links = links.filter((x) => x.label !== "My Companies");
  }

  if (!menusConfig?.my_pitches) {
    links = links.filter((x) => x.label !== "My Pitches");
  }

  return isMobile ? [...mobileLinks, ...links] : links;
};

export const getIsRouteActive = (href?: string) => {
  if (!href) return false;

  return (
    window.location.pathname === href ||
    window.location.pathname.includes(`${href}/`)
  );
};
